module.exports = __webpack_public_path__ + "media/site_templates/www.paintersnearme.net.au/images/our_services_1-5aa44e4fa4b2f45faff993abf0ced3d1.jpg";